module.exports = __webpack_public_path__ + "static/media/rubik-v9-latin-500.bec92433.woff";